import axios from "axios"
import ApiStore from "./ApiStore";

export class CashflowStore extends ApiStore{
  constructor() {
    super();

  }

  loadCashflowSummaryYearRecord(year,completeFunc){
    axios.get('/cashflow/summary_year_record?year='+year)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCashflowSummaryMonthRecord(year,month,completeFunc){
    axios.get('/cashflow/summary_month_record?year='+year+'&month='+month)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCashflowRecord(year,month,day,category,completeFunc){
    axios.get('/cashflow/record?year='+year+'&month='+month+'&day='+day+'&category='+category)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCashflowRecordRange(start,end,category,completeFunc){
    axios.get('/cashflow/record?start='+start+'&end='+end+'&category='+category)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCashflowIncentiveExpenseRecord(params,completeFunc){
    axios.get('/cashflow/incentive_expense_record',{params:params})
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveCashflowRecord(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/record',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveCashflowIncentiveExpenseRecord(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/incentive_expense_record',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveIncentivePayee(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/incentive_expense_payee',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveRecordCategory(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/record_category',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateRecordCategory(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/record_category/edit',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveCompany(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/record_company',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updateCompany(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/cashflow/record_company/edit',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadRecordCategory(completeFunc) {
    axios.get('/cashflow/record_category')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCompany(completeFunc) {
    axios.get('/cashflow/record_company')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadRecordIncentiveExpensePayee(completeFunc){
    axios.get('/cashflow/record_incentive_expense_payee')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadIncentiveExpensePayee(viewMode,query,completeFunc) {
    let param = viewMode=='all'?'':'?q='+query
    let url = '/cashflow/incentive_expense_payee' + param
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  delIncentivePayee(payeeId, completeFunc, errorFunc) {

    console.log('payeeId', payeeId)
    axios.delete('/cashflow/incentive_expense_payee/' + payeeId)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }
  
  syncDocumentDetail(cf,completeFunc,errorFunc){
    axios.get('/cashflow/sync_document_detail?cf='+cf)
    .then(function(response){
      //console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      if(errorFunc!==undefined)
        errorFunc(error)
    })
  }

  loadDocumentDetail(cf,completeFunc,errorFunc){
    axios.get('/cashflow/document_detail/?cf='+cf+'&cat=cashflow')
    .then(function(response){
      //console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      if(errorFunc!==undefined)
        errorFunc(error)
    })
  }

  loadDocumentFile(cf,name,completeFunc,errorFunc){
    axios.get('/cashflow/document_file/?cf='+cf+'&name='+name)
    .then(function(response){
      //console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      if(errorFunc!==undefined)
        errorFunc(error)
    })
  }

  saveDocumentDetail(postData,completeFunc,errorFunc){
    
    axios.post('/cashflow/document_detail',postData)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  delDocumentDetail(cf,name,completeFunc,errorFunc){
    
    axios.delete('/cashflow/document_detail/'+cf+'/'+name)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}  

export default new CashflowStore()


// WEBPACK FOOTER //
// ./src/stores/CashflowStore.js